export default class CtaBanner {
    visible = false;

    // init() {
    //     pegasus.parallaxScroll(this.$refs.paralaxScrollElem);

    //     const textContent = this.$el.querySelector(".text-content");
    //     const background = this.$el.querySelector(".colour-overlay");

    //     window.addEventListener("scroll", () => {
    //         if (!this.scrolling) {
    //             return;
    //         }

    //         const mainContainer = this.$el;
    //         const rect = mainContainer.getBoundingClientRect();
    //         const ctaContainer = this.$el.querySelector(".sticky-element");
    //         const scrollTrack = mainContainer.offsetHeight - ctaContainer.offsetHeight;
    //         const scrollPercent = (ctaContainer.offsetTop / scrollTrack) * 100;

    //         this.scrollPercent = scrollPercent;

    //         // As scrollPercent increases from 0 to 100, the scale of textContent should increase from .75 to 1
    //         const scale = 0.75 + (scrollPercent / 100) * 0.25;
    //         textContent.style.transform = `scale(${scale})`;

    //         // As scrollPercent increases from 0 to 100, the opacity of textContent should increase from 0 to 1 and the opacity of background should decrease from 1 to 0.3
    //         const opacity = scrollPercent / 100;
    //         textContent.style.opacity = opacity;

    //         console.log('opacity', opacity);
    //         // Increase the background opacity as the scroll percentage increases
    //         background.style.opacity = 0 + (opacity * 0.5);

    //         // const transform = Math.abs(rect.top) * 0.025;

    //         // this.$refs.paralaxScrollElem.style.transform = `translateY(${transform}px)`;
    //     });
    // }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("ctaBanner", () => new CtaBanner());
});
